// components/BusinessHeader.tsx
import React from "react";
import { BusinessPrintData, OrganizationDetails } from "../hooks/types";
import { useUser } from "src/shared/context/UserContext";
import noImage from "src/assets/Images/imetanic-logo.png";

interface BusinessHeaderProps {
  businessPrint: BusinessPrintData;
  organizationData: OrganizationDetails[];
}

const BusinessHeader: React.FC<BusinessHeaderProps> = ({ businessPrint, organizationData }) => {
  const { user } = useUser();
  const displayLogo = user?.companyLogo || businessPrint.logo;

  return (
    <div style={{ textAlign: "center", marginBottom: "10px" }}>
      {displayLogo && (
        <div className="flex justify-center items-center w-full" id="logo-container">
          <img
            src={displayLogo}
            alt="Logo"
            className="w-16 h-16 rounded-full"
            id="business-logo"
            onError={(e) => {
              (e.target as HTMLImageElement).src = noImage;
            }}
          />
        </div>
      )}
      <h2 style={{ margin: "5px 0", fontSize: "18px", fontWeight: "bold" }}>{businessPrint.name}</h2>
      <h2 style={{ margin: "5px 0", fontSize: "18px", fontWeight: "bold", direction: "rtl" }}>{user?.orgArabicName}</h2>
      <p style={{ margin: "3px 0", fontSize: "12px" }}>{user?.addresses.addressLine1}</p>
      {user?.phones && <div style={{ textAlign: "center", margin: "5px 0", fontSize: "12px" }}>{user.phones[0].phone}</div>}
    </div>
  );
};

export default BusinessHeader;
